<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { getToolsClient } from '@/services/tools'
import * as sensorApi from '@/services/rest-api-sms/lib/sensor/sensor'

const toolsAxios = getToolsClient()
export default {
  components: {},
  mixins: [validationMixin],
  props: {
    title: { type: String, default: 'Pengaturan Buzzer 2' },
    modal: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    vehicleId: { type: Number, default: null },
    deviceCode: { type: Number, default: null },
    region: {
      type: String,
      default: 'SG',
    },
  },
  data() {
    return {
      pinCode: null,
      form: {
        selected: null,
        vehicle: {
          alert_operational_start: null,
          alert_operational_end: null,
        },
        alert_min_time: null,
        status_text: null,
      },
      alertCodes: null,
      selectedAlertCodes: [],
      originalForm: {},
      isDisabled: true,
      isDisabledSaveButton: true,
      sensors: [],
      modalConfirm: false,
      buzzerOptions: [
        { id: 25, name: 'Buzzer 1' },
        { id: 29, name: 'Buzzer 2' },
      ],
      statusOptions: [
        { id: true, name: 'Ya' },
        { id: false, name: 'Tidak' },
      ],
      statusText: null,
    }
  },
  validations: {
    form: {
      selected: { required },
      alert_min_time: {
        minValue(value) {
          return !value || parseFloat(value) >= 1
        },
      },
    },
  },
  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(newVal) {
        this.$emit('update:isLoading', newVal)
      },
    },
    reorderedAlertCodes() {
      if (!this.alertCodes) return []

      const columns = 2
      const rows = Math.ceil(this.alertCodes.length / columns)
      let reordered = new Array(this.alertCodes.length)

      let index = 0
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < columns; col++) {
          let originalIndex = col * rows + row
          if (originalIndex < this.alertCodes.length) {
            reordered[index++] = this.alertCodes[originalIndex]
          }
        }
      }

      return reordered.filter(Boolean)
    },
  },
  methods: {
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
    },
    async handleSubmit(bvModalEvent) {
      this.loading = true
      this.isDisabled = true
      bvModalEvent.preventDefault()
      this.$v.form.$touch()

      if (this.$v.form.$error) {
        this.loading = false
        this.isDisabled = false
        return
      }

      let payload = {}

      payload.status_text = this.form.status_text
      payload.alert_min_time =
        this.form.alert_min_time === '' || this.form.alert_min_time === '0'
          ? null
          : typeof this.form.alert_min_time === 'number'
          ? this.form.alert_min_time
          : Number(this.form.alert_min_time)

      const response = await sensorApi.update(
        this.vehicleId,
        this.form.selected,
        this.pinCode,
        payload,
        this.region
      )

      if (response?.status === 200) {
        await this.$nextTick()
        this.$toast.success(this.$t('global.success.save'))
        this.loading = false
        this.isDisabled = false
        this.$bvModal.hide('modal-form-set-buzzer')
        return
      }

      if (!response?.data) {
        this.loading = false
        this.isDisabled = false
        return
      }
    },

    async getSensors() {
      const options = {
        method: 'GET',
        url: `/masterdata/sensor/${this.vehicleId}`,
        headers: {
          'X-Region': this.region,
        },
      }

      await toolsAxios(options)
        .then((res) => {
          this.sensors = res.data.sensor_type
          this.originalForm = { ...this.form }
        })
        .catch((err) => {
          this.$toast.error(err)
        })
    },

    async getAlertCodes() {
      this.alertCodes = []
      const options = {
        method: 'GET',
        url: `/sensor/alert_codes?sensor_code=${this.form.selected}&device_code=${this.deviceCode}`,
        headers: {
          'X-Region': this.region,
        },
      }

      await toolsAxios(options)
        .then((res) => {
          this.alertCodes = res.data.alert_codes
        })
        .catch((err) => {
          this.handleError(err)
          this.isDisabledSaveButton = true
          this.resetForm()
        })
    },

    handleError(error) {
      if (error.response) {
        this.$toast.error(error.response.data.error)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    async onChangeBuzzer() {
      this.isDisabledSaveButton = true
      this.isDisabled = true
      if (this.form.selected) {
        await this.getSensors()

        const selectedSensor = this.sensors.find(
          (sensor) => sensor.sensor_code === this.form.selected
        )

        if (!selectedSensor) {
          this.$toast.error('Sensor Not Found')
          this.resetForm()
          return
        }

        await this.getAlertCodes()

        this.form.vehicle.alert_operational_start =
          selectedSensor.vehicle.alert_operational_start?.slice(0, 5)
        this.form.vehicle.alert_operational_end =
          selectedSensor.vehicle.alert_operational_end?.slice(0, 5)
        this.form.alert_min_time = selectedSensor.alert_min_time
          ? selectedSensor.alert_min_time
          : '30'
        this.form.status_text = selectedSensor.status_text
        if (selectedSensor.status_text) {
          this.selectedAlertCodes = selectedSensor.status_text.split(',')
        } else {
          this.selectedAlertCodes = []
        }
        this.pinCode = selectedSensor.pin_code
        await this.$nextTick()

        this.originalForm = { ...this.form }
        this.isDisabled = false
        this.isDisabledSaveButton = false
      }
    },

    handleCheckboxChange() {
      this.form.status_text = this.selectedAlertCodes.join(',')
    },

    formatRange(event) {
      const charCode = event.keyCode || event.which
      const charStr = String.fromCharCode(charCode)
      const input = event.target
      const currentValue = input.value

      if (!charStr.match(/[0-9.]/)) {
        event.preventDefault()
        return
      }

      if (charStr === '.' && currentValue.includes('.')) {
        event.preventDefault()
        return
      }

      const cursorStart = input.selectionStart
      const cursorEnd = input.selectionEnd

      const newValue = currentValue.slice(0, cursorStart) + charStr + currentValue.slice(cursorEnd)

      const [integerPart, decimalPart] = newValue.split('.')
      const integerPartSplitted = integerPart.split('')

      if (integerPartSplitted.length == 2) {
        if (
          Number(integerPartSplitted[0]) !== 1 &&
          Number(integerPartSplitted[0]) !== 2 &&
          Number(integerPartSplitted[0]) !== 0
        ) {
          event.preventDefault()
          return
        }
      }

      if (integerPart.length > 2 || integerPart > 24) {
        event.preventDefault()
        return
      }

      if (decimalPart) {
        if (decimalPart > 59) {
          event.preventDefault()
          return
        }

        if (decimalPart.length > 2) {
          event.preventDefault()
          return
        }

        const decimalPartSplitted = decimalPart.split('')

        if (![0, 1, 2, 3, 4, 5].includes(Number(decimalPartSplitted[0]))) {
          event.preventDefault()
          return
        }
      }
    },

    formatRangeV2(event) {
      const charCode = event.keyCode || event.which
      const charStr = String.fromCharCode(charCode)
      const input = event.target
      const currentValue = input.value

      if (!charStr.match(/[0-9.]/)) {
        event.preventDefault()
        return
      }

      if (charStr === '.' && currentValue.includes('.')) {
        event.preventDefault()
        return
      }

      const cursorStart = input.selectionStart
      const cursorEnd = input.selectionEnd

      const newValue = currentValue.slice(0, cursorStart) + charStr + currentValue.slice(cursorEnd)

      if (newValue.length > 5) {
        event.preventDefault()
        return
      }

      const [hour, minute] = newValue.split('.')

      if (hour && (hour.length > 2 || Number(hour) > 23)) {
        event.preventDefault()
        return
      }

      if (minute && (minute.length > 2 || Number(minute) > 59)) {
        event.preventDefault()
        return
      }
    },

    resetForm() {
      this.form = {
        selected: null,
        status: null,
        vehicle: {
          alert_operational_start: null,
          alert_operational_end: null,
        },
        alert_min_time: null,
        status_text: null,
      }
      this.originalForm = { ...this.form }
      this.isDisabled = true
    },
  },

  watch: {
    'form.selected'(newVal) {
      if (newVal === null || newVal === '') {
        this.isDisabled = true
        this.isDisabledSaveButton = true

        this.resetForm()

        return
      }
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form-set-buzzer"
      :title="title"
      size="xl"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
    >
      <div class="card-body mc-modal__filter p-2">
        <b-form @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col cols="6">
              <div class="mb-2">
                <label class="mt-3 required">Jenis Buzzer</label>
                <v-select
                  v-model="form.selected"
                  :options="buzzerOptions"
                  placeholder="Pilih jenis buzzer"
                  label="name"
                  :reduce="(v) => v.id"
                  :class="{
                    'is-invalid': $v.form.selected.$error,
                  }"
                  @input="onChangeBuzzer"
                >
                </v-select>
                <div v-if="$v.form.selected.$error" class="invalid-feedback">
                  <span v-if="!$v.form.selected.required"> This field is required </span>
                </div>
              </div>
            </b-col>

            <b-col cols="6">
              <div class="mb-2"></div>
            </b-col>

            <b-col cols="6">
              <label class="mt-3">{{ $t('sensor.operationalTimeStart') }}</label>
              <b-form-input
                v-model="form.vehicle.alert_operational_start"
                type="text"
                :placeholder="$t('sensor.operationalTimeStart')"
                :disabled="true"
                @keypress="formatRangeV2"
              >
              </b-form-input>
            </b-col>

            <b-col cols="6">
              <label class="mt-3">{{ $t('sensor.operationalTimeFinish') }}</label>
              <b-form-input
                v-model="form.vehicle.alert_operational_end"
                type="text"
                :placeholder="$t('sensor.operationalTimeFinish')"
                :disabled="true"
                @keypress="formatRangeV2"
              >
              </b-form-input>
            </b-col>

            <b-col cols="6">
              <label class="mt-3">{{ $t('sensor.alertMinTime') }}</label>
              <b-form-input
                v-model="form.alert_min_time"
                type="number"
                :placeholder="$t('sensor.alertMinTime')"
                :class="{
                  'is-invalid': $v.form.alert_min_time.$error,
                }"
                :disabled="isDisabled"
              >
              </b-form-input>
              <div v-if="$v.form.alert_min_time.$error" class="invalid-feedback">
                <span v-if="!$v.form.alert_min_time.notZero"
                  >Nilai tidak boleh lebih kecil dari 1</span
                >
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4" v-if="this.form.selected && this.alertCodes">
            <b-col cols="8">
              <b-form-group label="Alert Yang Diaktifkan" label-for="alert-codes-checkbox-group">
                <b-form-checkbox-group
                  v-model="selectedAlertCodes"
                  name="alert-codes-checkbox-group"
                  id="alert-codes-checkbox-group"
                  class="d-grid mt-3"
                  style="grid-template-columns: repeat(2, 1fr); gap: 8px"
                >
                  <div
                    v-for="alertCode in reorderedAlertCodes"
                    :key="alertCode.alert_code"
                    @change="handleCheckboxChange(alertCode.alert_code)"
                    class="d-flex align-items-center"
                  >
                    <b-form-checkbox :value="alertCode.alert_code">
                      <span class="ms-2">{{ alertCode.description_eng }}</span>
                    </b-form-checkbox>
                  </div>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button
              @click="handleSubmit"
              variant="primary"
              :disabled="loading || isDisabledSaveButton"
            >
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
